import { forwardRef } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  top: number
  width: number
  showing: boolean
  selectedQuantity?: number
}

const TheadFloat = forwardRef<HTMLDivElement, Props>(
  ({ children, top, width, showing, selectedQuantity = 0 }, ref) => {
    return (
      <div
        className={clsx(
          'z-fixed border-secondary bg-surface-secondary fixed mt-px flex w-full items-center overflow-hidden border-b',
          !showing && 'hidden'
        )}
        ref={ref}
        style={{ top, width }}
      >
        {children}
        {selectedQuantity > 0 && (
          <TableHeadItem float covering type='low'>
            <Text weight='bold'>{selectedQuantity}個を選択済み</Text>
          </TableHeadItem>
        )}
      </div>
    )
  }
)

export default TheadFloat
